import SignUpSupplierSuccessPage from './signUpSupplierSuccess';

export default SignUpSupplierSuccessPage;
